import { render, staticRenderFns } from "./EventPostEditView.vue?vue&type=template&id=bd478446&scoped=true&"
import script from "./EventPostEditView.vue?vue&type=script&lang=ts&"
export * from "./EventPostEditView.vue?vue&type=script&lang=ts&"
import style0 from "./EventPostEditView.vue?vue&type=style&index=0&id=bd478446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd478446",
  null
  
)

export default component.exports